<template>
    <project-picker-new
        v-model="project"
        class="w-full min-w-[200px] ag-custom-component-popup"
        default-open
        @on-account-picker-closed="stopEditing"
    />
</template>

<script setup lang="ts">
import {SubAccount} from '@/subaccount/types/SubAccount'
import {computed} from 'vue'
import {fetchSuppliers, updateSubAccount} from '@/subaccount/subAccount.service'
import ProjectPickerNew from '@/dimensions/ProjectPickerNew.vue'

const props = defineProps({
    params: {
        type: Object as () => {
            value: string,
            node: {
                data: SubAccount
            },
            stopEditing: () => void
        },
        required: true
    }
})

const subAccount = computed(() => {
    return props.params.node.data
})

const project = computed({
    get: () => {
        return subAccount.value.metadata.suggestions.project || ''
    },
    set: async (value) => {
        const updatedSubAcc = {
            ...subAccount.value,
            metadata: {
                ...subAccount.value.metadata,
                suggestions: {
                    ...subAccount.value.metadata.suggestions,
                    project: value
                }
            }
        }
        await updateSubAccount(updatedSubAcc)
        await fetchSuppliers()
        stopEditing()
    }
})

const stopEditing = () => {
    props.params.stopEditing()
}

</script>

<style scoped>

</style>